<template>
  <div>
    <panel title="Dokumenty księgowe">
      <decision-benefit-form-details :decision="decision" />

      <w-table
        :add-button-entity-type="addButtonEntityType"
        :add-button-entity-id="documentId"
        :entity-type="entityType"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="0"
        :per-page="-1"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <template slot="footer">
        <w-button class="btn-secondary" text="Wróć" @click="goBack" />
      </template>
    </panel>

    <invoice-modal
      :id="idToEdit"
      :show="showModal"
      :max-to-pay="maxToPay"
      @save="add"
      @close="hideModal"
      @update="update"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DecisionBenefitFormDetails from '@/components/forms/invoice/DecisionBenefitFormDetails';
import InvoiceModal from '@/components/modals/InvoiceModal';
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { TableName } from '@/enums/tableName';
import { dateTime } from '@/filters/date';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';
import { prepareQuery } from '@/utils/prepareQuery';

const messages = {
  listError: Errors.INVOICE_CANNOT_LIST,
  getError: Errors.INVOICE_CANNOT_GET,
  added: Successes.INVOICE_ADDED,
  addError: Errors.INVOICE_CANNOT_ADD,
  updated: Successes.INVOICE_UPDATED,
  updateError: Errors.INVOICE_CANNOT_UPDATE,
  deleteConfirm: Successes.INVOICE_CONFIRM_DELETE,
  deleted: Successes.INVOICE_DELETED,
  deleteError: Errors.INVOICE_CANNOT_DELETE
};

// @vuese
// Lista faktur
// @group Document
export default {
  components: { InvoiceModal, Panel, WTable, DecisionBenefitFormDetails },
  mixins: [listMixin('invoice', messages)],
  data() {
    return {
      actions: DEFAULT_TABLE_ACTIONS,
      columns: [
        { name: 'number', displayName: 'Numer' },
        { name: 'price', displayName: 'Kwota' },
        { name: 'priceToPay', displayName: 'Kwota do wypłaty' },
        { name: 'created', displayName: 'Data wprowadzenia', nameTransformer: dateTime }
      ],
      entityType: 'invoice',
      addButtonEntityType: 'document'
    };
  },
  computed: {
    ...mapState({
      decision: state => state.documentIndex.data.currentDecision
    }),

    entityId() {
      return this.$route.params.documentId.toString();
    },

    maxToPay() {
      const currentMonth = new Date().getMonth();
      const alreadyPaid = this.list
        .filter(item => new Date(item.created).getMonth() === currentMonth)
        .map(item => item.priceToPay)
        .reduce((a, b) => a + b, 0);

      return this.decision.data.amount - alreadyPaid;
    },

    documentId() {
      return tryParseInt(this.$route.params.documentId);
    }
  },
  methods: {
    // @vuese
    // Wraca do dokumentu
    goBack() {
      this.$router.push({ name: 'documentDetails' });
    },

    // @vuese
    // Dodaje dane encji do zapisywanego modelu
    prepareModel(data) {
      data.entityType = TableName.document;
      data.entityId = this.entityId;
      return data;
    },

    // @vuese
    // Dodaje dane encji do filtrów
    getFilters(route) {
      return { entityType: TableName.document, entityId: this.entityId, count: -1 };
    },

    // @vuese
    // Przeładowuje listę po dodaniu faktury
    afterAdd() {
      this.updateList(this.$route, undefined, () => void 0);
    },

    // @vuese
    // Przeładowuje listę po aktualizacji faktury
    afterUpdate() {
      this.updateList(this.$route, undefined, () => void 0);
    }
  }
};
</script>
